import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../styles/AdminStyles.css';

const AdminMenu = () => {
  return (
    <div className="admin-sidebar">
      <div className="admin-menu-card">
        <h4 className="admin-menu-title">
          <span>⚙️</span> لوحة الإدارة
        </h4>
        <nav className="admin-menu-list">
          <NavLink to="/dashboard/admin" end>
            <span className="admin-menu-icon">📊</span> لوحة المعلومات
          </NavLink>
          <NavLink to="/dashboard/admin/create-category">
            <span className="admin-menu-icon">📁</span> إنشاء قسم
          </NavLink>
          <NavLink to="/dashboard/admin/create-product">
            <span className="admin-menu-icon">➕</span> إنشاء منتج
          </NavLink>
          <NavLink to="/dashboard/admin/products">
            <span className="admin-menu-icon">📦</span> المنتجات
          </NavLink>
          <NavLink to="/dashboard/admin/orders">
            <span className="admin-menu-icon">🧾</span> الطلبات
          </NavLink>
          <NavLink to="/dashboard/admin/payments">
            <span className="admin-menu-icon">💳</span> معاملات الدفع
          </NavLink>
          <NavLink to="/dashboard/admin/users">
            <span className="admin-menu-icon">👥</span> المستخدمين
          </NavLink>
          <NavLink to="/dashboard/admin/settings">
            <span className="admin-menu-icon">⚙️</span> الإعدادات
          </NavLink>
        </nav>
      </div>
    </div>
  );
};

export default AdminMenu;
